import * as _ from 'lodash';
import { roleIdToJapaneseRoleName } from './roleUtility';
const { dataLayer } = window;
/**
 * GTM専用に格納する値はsessionStorageに入れkeyの末尾にgtmを付与する
 * 各keyがGTM以外でも使用する必要が出た場合、sessionStorageServiceなど通常の実装を行い、
 * このファイルからは該当keyを削除してください (field_name_gtm => field_name)
 */
const FIELD_NAME_GTM = 'field_name_gtm';
const COMPANY_NAME_GTM = 'company_name_gtm';
const COMPANY_BRANCH_NAME = 'company_branch_name_gtm';
const USER_CREATED_AT_GTM = 'user_created_at_gtm';
const PRIME_COMPANY_IDS_GTM = 'prime_company_ids_gtm';

export const isAvailableGTM = () => {
  return hasGTMId();
};

/**
 * GTMに送信する値を更新する際は同時にdataLayerを更新する
 * user_id、role_id変更時は他の項目も更新されるため省略
 * 他company_idなども同時にnameを更新するため省略
 *
 * 追随しない場合は追加が必要
 */
export const updateDataLayer = () => {
  if (dataLayer && isAvailableGTM()) {
    const data = getGtmSendData();
    dataLayer.push(data);
  }
};

// GTM専用のsessionStorageのkeyを削除する
export const removeSessionItemsForGTM = () => {
  sessionStorage.removeItem(FIELD_NAME_GTM);
  sessionStorage.removeItem(COMPANY_NAME_GTM);
  sessionStorage.removeItem(COMPANY_BRANCH_NAME);
  sessionStorage.removeItem(PRIME_COMPANY_IDS_GTM);
  sessionStorage.removeItem(USER_CREATED_AT_GTM);
};

export const setFieldNameForGTM = fieldName => {
  if (!_.isNil(fieldName)) {
    sessionStorage.setItem(FIELD_NAME_GTM, fieldName);
  }
  updateDataLayer();
};

export const setCompanyNameForGTM = companyName => {
  if (!_.isNil(companyName)) {
    sessionStorage.setItem(COMPANY_NAME_GTM, companyName);
  }
  updateDataLayer();
};

// 協力会社管理者の場合、所属会社と所属支店は元請選択画面までは取得出来た1件目を使う
export const setCompanyBranchNameForGTM = companyBranchName => {
  if (!_.isNil(companyBranchName)) {
    sessionStorage.setItem(COMPANY_BRANCH_NAME, companyBranchName);
  }
  updateDataLayer();
};

export const setUserCreatedAtForGTM = createdAt => {
  if (!_.isNil(createdAt)) {
    sessionStorage.setItem(USER_CREATED_AT_GTM, createdAt);
  }
  updateDataLayer();
};

export const setListPrimeCompanyIdsForGTM = listPrimeCompanyIds => {
  if (!_.isNil(listPrimeCompanyIds)) {
    sessionStorage.setItem(
      PRIME_COMPANY_IDS_GTM,
      JSON.stringify(listPrimeCompanyIds)
    );
  }
  updateDataLayer();
};

export const getGtmSendData = () => {
  const roleId = gtmDataShaping(localStorage.getItem('role_id'));
  const roleName = getRoleName(roleId);

  // 送信データ：BLDE_V2-18799
  const data = {
    user_id: gtmDataShaping(localStorage.getItem('user_id')),
    role_name: roleName,
    company_id: gtmDataShaping(sessionStorage.getItem('company_id')),
    company_name: gtmDataShaping(getCompanyName()),
    company_branch_id: gtmDataShaping(
      sessionStorage.getItem('company_branch_id')
    ),
    company_branch_name: gtmDataShaping(getCompanyBranchName()),
    prime_company_ids: getPrimeCompanyListIds(),
    field_id: gtmDataShaping(sessionStorage.getItem('field_id')),
    field_name: gtmDataShaping(getFieldName()),
    created_at: gtmDataShaping(getUserCreatedAt()),
  };
  return data;
};

const hasGTMId = () => {
  if (
    !_.isNil(process.env.REACT_APP_GTM_ID) &&
    process.env.REACT_APP_GTM_ID !== ''
  ) {
    return true;
  }
  return false;
};

const gtmDataShaping = data => {
  if (_.isNil(data) || data === 'null') {
    return '';
  }
  return data;
};

/**
 * GTM要因でエラー画面に遷移させたくないため、roleIdの名前が判定できなかった場合は空白を返す
 */
const getRoleName = roleId => {
  try {
    return roleIdToJapaneseRoleName(roleId);
  } catch (e) {
    return '';
  }
};

const getCompanyName = () => {
  return sessionStorage.getItem(COMPANY_NAME_GTM);
};
const getFieldName = () => {
  return sessionStorage.getItem(FIELD_NAME_GTM);
};
const getCompanyBranchName = () => {
  return sessionStorage.getItem(COMPANY_BRANCH_NAME);
};
const getUserCreatedAt = () => {
  return sessionStorage.getItem(USER_CREATED_AT_GTM);
};
const getPrimeCompanyListIds = () => {
  const primeCompanyIdsGtm = sessionStorage.getItem(PRIME_COMPANY_IDS_GTM);
  if (primeCompanyIdsGtm) {
    return JSON.parse(primeCompanyIdsGtm);
  }
  return [];
};



// WEBPACK FOOTER //
// ./src/utilities/gtm.js